import {
  apiClient,
  getStoredAuth,
  resolveApiErrorMessage,
} from './authApi';

function withAuthHeaders() {
  const { accessToken } = getStoredAuth();

  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
  };
}

function withNoCacheHeaders() {
  return {
    ...withAuthHeaders(),
    'Cache-Control': 'no-cache, no-store, max-age=0',
    Pragma: 'no-cache',
    Expires: '0',
  };
}

export const adminApi = {
  async listUsers(options = {}) {
    const { bustCache = false, search = '' } = options;
    const params = {};

    if (String(search || '').trim()) {
      params.search = String(search || '').trim();
    }
    if (bustCache) {
      params._t = Date.now();
    }

    const response = await apiClient.get('/admin/users', {
      headers: withNoCacheHeaders(),
      ...(Object.keys(params).length > 0 ? { params } : {}),
    });

    return response.data;
  },

  async inviteUser(payload) {
    const response = await apiClient.post('/admin/users/invite', payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async updateUserAccess(userId, payload) {
    const response = await apiClient.put(`/admin/users/${userId}/access`, payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async resetUserPassword(userId) {
    const response = await apiClient.post(`/admin/users/${userId}/reset-password`, {}, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async listScopes(options = {}) {
    const { bustCache = false } = options;
    const response = await apiClient.get('/admin/scopes', {
      headers: withNoCacheHeaders(),
      ...(bustCache ? { params: { _t: Date.now() } } : {}),
    });

    return response.data;
  },
};

export function resolveAdminApiError(error) {
  return resolveApiErrorMessage(error, 'Failed to process admin request.');
}
